<template>
	<div class="thankyou">
		<div class="container-fluid">
			<div class="row">
				<div class="col-12 newThankuWrap">
					<h2 class="forDesktop discount-color w-100" style="color: #349e44; font-size: 25px; line-height: 45px; font-family: 'lhmRegular'; padding: 18px; padding-bottom: 0px; ">Your order is placed</h2>
						<div
					class="orderId forDesktop w-100"
					style="font-size: 18px; font-family: 'lhmRegular'; " >
					Order ID. 
					<router-link to="/my-order.html" >
						{{ orderNo }}</router-link >
						
					</div>
					<img src="img/thankuImg.png" class="img-fluid m-auto" alt="" />
						<h2 class="forMobile  discount-color">Your order is Confirmed </h2>
						
					<div class="thankuBtns mt-4">
						<!-- <button class="btn thankuTrack forDesktop">Track Order</button> -->
						<button class="btn thankuShopping" @click="$router.push('/')">
							Continue Shopping
						</button>
						<button @click="$router.push('/my-order.html')" class="btn thankuShopping">
							<span to="/my-order.html" class="text-white">
								View Order
							</span>
						</button>
					</div>
					
					<div class="thankuBox">
						<h6>Thank You!</h6>
						<p class="text-success mb-1">Order Confirmed</p>
					</div>

					<p class="thankuText forDesktop my-3">
						You will receive an order
						confirmation on your email shortly with the selected delivery slots.
					</p>
					<p class="orderIdMobile">
						Order ID.

						<router-link
							to="/my-order.html"
						>
							{{ orderNo }}</router-link
						>
					</p>
					<!-- <p>This order is expected to be delivered in approx {{this.delivery_msg}}. Details of this order are listed below. <br class="forDesktop"> You will also receive this order confirmation via SMS within a few minutes.</p> -->

					<!-- <div class="thenkuPriceDetails forMobile">
						<p class="text-success my-2" v-if="payment_method == 'cod'">
							Cash on Delivery
						</p>
						<p class="text-success my-2" v-if="payment_method == 'razorpay'">Pre Paid</p>
							<p class="text-success my-2" v-else>WNDW Credits</p>

						<p class="mb-0 py-1">Delivery in {{ delivery_msg }}</p>
					</div> -->
					<div class="row">
						<div
							class="col-md-8 m-auto thankuProduct"
							v-for="(item, i) in order"
							:key="i"
						>
							<div class="thankuMsg"></div>
							<div class="row">
								<div class="col-md-12">
									<span class="thankuImgWrap">
										 <responsive-image
            
											v-bind:desktop="`${$root.image_url_c}inside/100x100/${item.image}`"
											v-bind:tab="`${$root.image_url_c}inside/100x100/${item.image}`"
											v-bind:mobile="`${$root.image_url_c}inside/100x100/${item.image}`"
											v-bind:default_image="`${$root.image_url_c}inside/100x100/${item.image}`"
										   custom_class= 'img-fluid'
												
										/>
										
									</span>
									<div class="thankuProductDetails">
										<h6>{{ item.store_name }}</h6>
										<p>{{ item.name }}</p>
										<h4>
											<small>{{ item.qty }} item</small>
										</h4>
										<!-- <small
											>You save
											<strong class="discount-color font-bold"><span>&#8377;</span>  199 </strong>on
											your order</small
										> -->
										<p class="discount-color font-bold mb-0 py-1"></p>

										<div class="deliveryMethodTime" style="position:relative">
											<span class="mb-0 mr-3">
												<span class="forDesktop">Scheduled for </span> <span> {{ item.time_slot }} </span> on
												<span> {{ item.time_slot_date }} </span>
											</span>
											
										<span class="mx-3 forDesktop">|</span>
											<p class="text-success px-3" v-if="payment_method == 'cod'">
												Payment Mode (Cash on Delivery)  </p>
											<p class="text-success px-3 forDesktop" v-if="payment_method == 'razorpay'">Payment Mode (Pre Paid)</p>
											<p class="text-success px-3 forDesktop"  v-if="payment_method != 'cod' && payment_method != 'razorpay'">Payment Mode (WNDW Credits)</p>
											<div class=" pr-2 forMobile float-right">
												<strong>  {{ item.row_total  | formatMoney}} </strong>
											</div>
											<div class="thenkuPriceDetails pr-2 forDesktop" style=" position: absolute; right: 0;">
												<strong>  {{ item.row_total  | formatMoney}} </strong>
											</div>
										</div>
									</div>
								</div> 
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-8 m-auto thankyouSummary">
						<div class="thankyouSummaryContent">
							<p class="mb-0 px-2">Sub Total</p>
							<strong class="mb-0 px-2">  {{sub_total | formatMoney}}</strong>
						</div>
						<div class="thankyouSummaryContent">
							<p class="mb-0 px-2">Discount</p>
							<strong class="success mb-0 px-2">  {{discountAmount | formatMoney}}</strong>
						</div>
						<!-- <div class="thankyouSummaryContent">
							<p class="mb-0">Coupon</p>
							<strong class="mb-0"><span>&#8377;</span>  </strong>
						</div> -->
						<div class="thankyouSummaryContent">
							<p class="mb-0  px-2">Shipping Charges</p>
							<strong class="mb-0  px-2">{{shippingCharge | formatMoney}}</strong>
						</div>
						</div>
					</div>

					<div class="row p-0">
						<div class="col-md-8 m-auto grandTotal py-2 px-0">
							<div class="thankyouSummaryContent">
								<strong class="px-2">Grand Total</strong>
								<strong class="px-2">  {{total | formatMoney}}</strong>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from "axios";
	import Slick from "vue-slick";
	export default {
		name: "Thankyou",
		metaInfo: {
			title: "Thank you",
			meta: [
				{
					name: "description",
					content:
						"Online fashion shopping destination for the modern women. Buy latest collection of online ethnic wear for women’s, W Kurtas, dresses, bottom wear, tops, palazzos, culottes, skirts, drapes and more.",
				},
				{
					property: "keywords",
					content:
						"Online Shopping for Women,  W for Woman, women’s dresses online, buy women’s dresses online",
				},
			],
		},
		components: {
			Slick,
		},
		data() {
			return {
				order: [],
				total: "",
				sub_total: "",
				date: "",
				time_slot: "",
				shipping_charges: "",
				cod_chaeges: "",
				order_date: "",
				gift_amount: "",
				net_amount: "",
				discountAmount: "",
				whatsnew_list: [],
				shipping_address: {
					name: "",
					address: "",
					pincode: "",
					city: "",
					state: "",
					phone: "",
				},
				payment_method: "",
				orderNo: "",
				razorpay: "",
				status: "",
				shippingCharge:'',
				discount_code: "",
				gtm_product: [],
				delivery_msg: "",
				wigzo_sku: [],
				team_sku: "",
				slickOptions1: {
					slidesToShow: 4,
					responsive: [
						{
							breakpoint: 997,
							settings: {
								slidesToShow: 3,
								slidesToScroll: 1,
								centerMode: true,
								centerPadding: "50px",
							},
						},
						{
							breakpoint: 767,
							settings: {
								arrows: false,
								slidesToShow: 2,
								slidesToScroll: 1,
								centerMode: true,
								centerPadding: "50px",
							},
						},
					],
					// Any other options that can be got from plugin documentation
				},
			};
		},
		created: function () {
			window.scrollTo(0, 0);
			(this.$root.error_message = ""),
				(this.$root.success_message = ""),
				(this.$root.breadcrumb = "Thankyou"),
				(this.$root.page_loader = false);
			this.$root.thankyou_status = false;
			$cookies.set(window.location.hostname.substring(10, 4) + "_thank", "");
		},

		methods: {
			// getWhatsnewInfo() {
			// 	axios
			// 		.get(this.$root.api_url + `/pim/pimresponse.php`, {
			// 			params: {
			// 				service: "teamup",
			// 				store: this.$root.store,
			// 				styles: this.team_sku,
			// 			},
			// 		})
			// 		.then((response) => {
			// 			this.whatsnew_list = response.data.result.team_up_products;
			// 			let currIndex = this.$refs.slicktwo.currentSlide();
			// 			this.$refs.slicktwo.destroy();
			// 			this.$nextTick(() => {
			// 				this.$refs.slicktwo.create();
			// 				this.$refs.slicktwo.goTo(currIndex, true);
			// 			});
			// 		})
			// 		.catch((error) => {
			// 			if (error.message === "Network Error") {
			// 				this.$root.error_message =
			// 					"Oops there seems to be some Network issue, please try again.";
			// 			}
			// 			window.scrollTo(0, 0);
			// 		});
			// },
			get_cart: function () {
				var form = new FormData();
				this.$root.page_loader = true;
				form.append("pcart", this.$root.pcart);
				form.append("page", "ty");
				form.append("cart_session", this.$root.cart_session);
				let config = { headers: { "Content-Type": "multipart/form-data" } };
				axios
					.post(this.$root.cart_api + "/order/get-order", form, config)
					.then((response) => {
						// console.log(response);
						if (response.data.success === true) {
							// console.log(response);
								console.log(response);
							this.$root.page_loader = false;
								this.shippingCharge =  response.data.shippingCharge
							this.$root.address = response.data.data[0].address;
							this.total = response.data.grandTotal;
							this.discountAmount = response.data.discountAmount;
							this.sub_total = response.data.subTotal;
							this.cod_chaeges = response.data.data.cod_charge;
							this.shipping_charge = response.data.data.shipping_charge;
							this.discount_code = response.data.data.discount_code;
							this.payment_method = response.data.data[0].payment_method;
							this.time_slot = response.data.data[0].is_express == 0 ? response.data.data[0].time_slot : 'Express Delivery';
							this.orderNo = response.data.data[0].order_increment_id;
						
							
							this.scheduleDate = response.data.data[0].date_of_order;
							this.status = response.data.data[0].status;
							this.gift_amount = response.data.data[0].gift_amount;
							this.net_amount = response.data.data[0].net_amount;
							this.order_date = response.data.data[0].order_date;
							this.shipping_address.name =
								response.data.data[0].maddress.full_name;
							this.shipping_address.address =
								response.data.data[0].maddress.street_address;
							this.shipping_address.pincode =
								response.data.data[0].maddress.pin_code;
							this.shipping_address.city = response.data.data[0].maddress.city;
							this.shipping_address.state = response.data.data[0].maddress.state;
							this.shipping_address.phone = response.data.data[0].maddress.phone;
							this.delivery_msg = response.data.data[0].delivery;

							//Products Array
							// let ProductsArray = []
							// Sorting Products array according to SKU

							response.data.data.forEach((products) => {
								
								products.products.forEach((product) => {
									let prod = {...product,time_slot_date:products.time_slot_date, time_slot: products.time_slot }
									this.order.push(prod);
								});
							});

							//  this.order = data
							// console.log(this.$root.pcart == response.data.data.order_quote_id);

							// this.order =  response.data.data.products;

							if (this.$root.pcart == response.data.data.order_quote_id) {
								$cookies.set(
									window.location.hostname.substring(10, 4) + "_cart",
									""
								);
								this.$root.cart_product = [];
								this.$root.pcart = "";
								this.$root.thankyou_cart = "";
								this.$root.cart_session = "";
							} else {
								//added to check only for reset
								$cookies.set(
									window.location.hostname.substring(10, 4) + "_cart",
									""
								);
								this.$root.cart_product = [];
								this.$root.pcart = "";
								this.$root.thankyou_cart = "";
								this.$root.cart_session = "";
								//till here
								this.$root.thankyou_cart = this.$root.pcart;
							}
							
							setTimeout(
								() =>
								fbq('track', 'Purchase', {currency: "INR", value: this.total}),
								100
							)
							setTimeout(
								() =>
								gtag('event', 'conversion', {
									'send_to': 'AW-337345994/wRMZCKGNp9QCEMr77aAB',
									'transaction_id': this.orderNo,
									'value': this.total,
									'currency': 'INR',
								}),
								100
							)
							// setTimeout(
							// 	() =>
							// 		this.$gtm.trackEvent({
							// 			event: "track-transaction",
							// 			category: "Ecommerce",
							// 			action: "Purchase",
							// 			label: this.order_no,
							// 			ecommerce: {
							// 				purchase: {
							// 					actionField: {
							// 						id: this.order_no,
							// 						affiliation: "",
							// 						revenue: this.total,
							// 						tax: "0",
							// 						shipping: "0",
							// 						coupon: this.discount_code,
							// 					},
							// 					products: this.gtm_product,
							// 				},
							// 			},
							// 		}),
							// 	100
							// );
							if (window.hasOwnProperty("wigzo") && typeof wigzo != "undefined") {
								setTimeout(() => wigzo("track", "buy", this.wigzo_sku), 1000);
							}
						} else {
							this.$root.page_loader = false;
							if (response.data.cart_session_status == false) {
								$cookies.set(
									window.location.hostname.substring(10, 4) + "_cart",
									"",
									"1y"
								);
								$cookies.set(
									window.location.hostname.substring(10, 4) + "_carts",
									"",
									"1y"
								);
								this.$root.pcart = "";
								this.$root.pcart = "";
								this.$root.cart_session = "";
								this.$root.cart_product = [];
							}
						}
					});
			},
		},
		mounted() {
			this.get_cart();
			
		},
		watch: {
			order: {
				handler: function (after, before) {
					this.gtm_product = [];
					for (let i = 0; i < this.order.length; i++) {
						let name = this.order[i].name;
						let id = this.order[i].master_sku;
						let price = this.order[i].selling_price;
						let variant = this.order[i].size;
						let category = this.order[i].category;
						let quantity = this.order[i].qty;
						this.gtm_product.push({
							name,
							id,
							price,
							variant,
							category,
							quantity,
						});
						this.wigzo_sku.push({ id });
					}
					for (var i = 0; i < this.order.length; i++) {
						this.team_sku += this.order[i].master_sku;
						this.team_sku += ",";
					}
					// setTimeout(() => this.getWhatsnewInfo(), 1000);
				},
			},
		},
	};
</script>
<style>
.thankuText {
	font-size: 16px;
    font-weight: 400;
}
.newThankuWrap>h2{
	color: #349e44;
	font-size: 36px;
	line-height: 45px;
	font-family: 'lhmRegular';
	padding: 18px;
	padding-bottom: 0px;
	}
	.thankyouSummary{
	padding: 10px 0px;
	border-bottom: 1px solid #626262;
	font-size: 16px;
	line-height: 23px;
	color: #333333;
	padding-bottom: 10px;
	}
.thankyouSummaryContent {
	display: flex;
	padding: 5px 0;
    justify-content: space-between;
}
.summaryDetail.total {
	padding: 17px 0px;
	font-family: 'lhmSemiBold';
}
.deliveryMethodTime {
	display: flex;
}
/* .deliveryMethodTime p:last-child{
	border-left: 1px solid #626262;
} */
.col-md-3.text-right.forDesktop {
    display: flex;
    align-self: flex-end;
   
    justify-content: flex-end;
}
	.thankyou {
		background: #fff;
		padding-bottom: 50px;
	}
	.thankYouHeader {
		display: flex;
		justify-content: space-between;
	}
	.orderId {
		text-align: center;
		color: #626262;
		margin-bottom: 30px;
	}
	.orderId a {
		font-family: 'lhmSemiBold';
		color: #626262 !important;
		text-decoration: none !important;
	}
	.newThankuWrap {
		text-align: center;
		margin-top: 50px;
	}
	.newThankuWrap img {
		max-width: 350px;
	}
	.newThankuWrap h2 {
		font-size: 36px;
		line-height: 45px;
		color: #626262;
		font-family: 'lhmSemiBold';
	}
	.orderIdMobile {
		display: none;
	}
	.thankuProduct img {
		width: 100px;
		float: left;
	}
	.thankuTrack {
		border: 1px solid #a2a2a2;
		max-width: 300px;
		background-color: transparent;
		width: 260px;
		margin: 11px 12px;
		display: inline-block;
	}
	.thankuShopping {
		border: 1px solid var(--main-color);
		max-width: 300px;
		background-color: var(--main-color);
		width: 260px;
		color: #fff;
		margin: 11px 15px;
		border-radius: 0;
		font-size: 1.4rem;
		padding: 8px;
	}
	.thankuProduct {
		border-bottom: 1px solid #a2a2a2;
		padding: 17px 0px;
	}
	.thankuProductDetails {
		float: left;
		text-align: left;
		display: inline-block;
		margin-left: 10px;
		font-family: 'lhmRegular';
		width: calc( 100% - 110px );
	}
	.thankuProductDetails h6 {
		font-size: 11px;
		margin-bottom: 0;
		font-weight: bold;
	}
	.thankuProductDetails p {
		font-size: 14px;
		margin: 0;
		padding: 4px 0px;
	}
	.thankuProductDetails h4 {
		font-size:  var(--font-size-heading);
		font-weight: 700;
	}

	body.thankyou {
		background-color: #f4f4f4;
	}
	.thankyou-container {
		padding: 30px;
		border-radius: 5px;
		width: 93%;
		margin: 60px auto;
		background-color: #fff;
		font-size: 14px;
		/* max-width: 800px; */
		-webkit-box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.05);
		box-shadow: 0 0px 15px 0 rgba(0, 0, 0, 0.05);
	}
	.thankyou-container .cart-title {
		font-size: 32px;
		color: var(--main-color);
	}
	.thankyou-container .order-detail-heading {
		border-bottom: 1px solid #dee2e6;
	}
	.thankyou-total p {
		margin: 0px;
		padding: 15px;
		border-bottom: 1px solid #c2c2c2;
	}
	.thankyou-total p strong {
		font-family: "Mulish", sans-serif;
	}
	.thankyou-total p span {
		float: right;
	}
	.thankyou-total.billing-address p {
		border: 0;
		padding: 5px 0;
	}
	.thankyou-total.billing-address p span {
		float: none;
	}
	.thankuBox {
		display: none !important;
	}
	.processes {
		margin: 0px;
	}
	.deliveryMethodTime .forDesktop{
		display: inline-block !important;
	}
	@media screen and (max-width: 767px) {
		.thankuImgWrap{
			max-height: 100px;
		}
		.deliveryMethodTime .forDesktop{
			display: none !important;
		}
		.deliveryMethodTime  {
			display: block;
		}
		.thankuProduct{
			padding: 10px;
		}
		.thankuProduct img{
			margin-right: 10px;
		}
		.thankuProductDetails{
			display: inherit;
			float: none;
			width: calc( 100% - 0px);
		}
		.orderIdMobile a{
			font-weight: 700;
			color: #626262;
		}
		.orderIdMobile {
			display: block;
			font-size:  var(--font-size-heading);
		}
		.thankuTrack {
			display: none;
		}
		.newThankuWrap h2 {
			font-size: 20px;
			font-weight: 700;
    		margin: 0;
			justify-content: center;
		}
		.thankuProduct {
			border: none;
			border-bottom: 10px solid #f4f4f5;
		}
		.thankYouHeader {
			display: none;
		}
		.thenkuPriceDetails {
			border-top: 1px dashed #a2a2a2;
			border-bottom: 1px dashed #a2a2a2;
			margin-bottom: 12px;
			text-align: center;
		}
		.forDesktop {
			display: block;
			order: -1;
		}
		.thankuTrack {
			display: none;
		}
		.thankuShopping {
			max-width: 100%;
			min-width: 95%;
		}
		.thankuBtns {
			position: fixed;
			bottom: 0px;
			left: 0;
			width: 100%;
			background: #fff;
			z-index: 99;
			-webkit-box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
			box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
		}
		.newThankuWrap img {
			max-width: 100%;
		}
	}
</style>